export default "__VITE_ASSET__265a9e44__"